import { DocumentData } from 'firebase/firestore';

export type SearchableItem = DocumentData & { id: string };

const normalize = (value: string): string =>
  value.normalize('NFKC').replace(/\s+/g, '').toLowerCase();

const getValueByPath = (obj: unknown, path: string): unknown =>
  path.split('.').reduce<unknown>((acc, key) => {
    if (acc && typeof acc === 'object' && key in (acc as Record<string, unknown>)) {
      return (acc as Record<string, unknown>)[key];
    }
    return undefined;
  }, obj);

export const fusejsSearch = (
  results: SearchableItem[],
  searchTerm: string,
  key: string,
): SearchableItem[] => {
  const needle = normalize(searchTerm);
  if (!needle) return results;

  return results.filter(item => {
    const value = getValueByPath(item, key);
    if (typeof value !== 'string') return false;
    return normalize(value).includes(needle);
  });
};
